import React, { useState, useEffect } from 'react'
import { Form } from 'lib/ui/components'
import { Input, Wrapper } from './styled'
import { ProductQtyWrapper } from 'scenes/Product/components/OptionsSection/components/ProductQtyInput/styled'

interface Props {
  value: number
  min: number
  max: number
  onChange: (param: number) => void
  isFormik?: boolean
  label?: string
  name?: string
}

export const SubscriptionFrequencyInput = ({
  value,
  min,
  max,
  onChange,
  isFormik = false,
  label,
  name
}: Props) => {
  const StyledWrapper = isFormik ? Form.Field : Wrapper
  const [internalValue, setInternalValue] = useState(value)
  const [valid, setValid] = useState(isValid(value.toString(), min, max))

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value
    setInternalValue(newValue ? parseInt(newValue) : 0)
    const newValid = isValid(newValue, min, max)
    setValid(newValid)
  }

  const handleBlur = () => {
    if (internalValue < min) {
      setInternalValue(min)
    } else if (internalValue > max) {
      setInternalValue(max)
    } else {
      setInternalValue(value)
    }
    setValid(true)
  }

  useEffect(() => {
    if (valid) {
      onChange(internalValue)
    }
  }, [internalValue, onChange, valid])

  return (
    <StyledWrapper
      className='form-field form-field--input'
    >
      {isFormik && (
        <Form.Label>{label}</Form.Label>
      )}
      <ProductQtyWrapper>
        <div>
          <Input
            isFormik={isFormik}
            type='number'
            name={name}
            className={valid ? '' : 'invalid'}
            value={internalValue}
            onChange={handleChange}
            onBlur={handleBlur}
            min={min}
            max={max}
          />
        </div>
      </ProductQtyWrapper>
      {!valid && (
        <div className='error-wrapper'>
          <Form.Error>Subscriptions are limited to 2-20 week intervals.</Form.Error>
        </div>
      )}
    </StyledWrapper>
  )
}

const isValid = (value: string, min: number, max: number) =>
  value !== '' &&
  value !== '-' &&
  (min === undefined || parseInt(value) >= min) &&
  (max === undefined || parseInt(value) <= max)
